import { render, staticRenderFns } from "./ReviewEvaluation.vue?vue&type=template&id=22fae326&scoped=true"
import script from "./ReviewEvaluation.vue?vue&type=script&lang=js"
export * from "./ReviewEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ReviewEvaluation.vue?vue&type=style&index=0&id=22fae326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fae326",
  null
  
)

export default component.exports